import { render, staticRenderFns } from "./SubmissionForm.vue?vue&type=template&id=7863b137&scoped=true&"
import script from "./SubmissionForm.vue?vue&type=script&lang=js&"
export * from "./SubmissionForm.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionForm.vue?vue&type=style&index=0&id=7863b137&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7863b137",
  null
  
)

export default component.exports